export const BOTTOM_SHEET_ANIMATION_DURATION = 250;
